var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnPaginationChevronUpHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7166 10.768C11.858 10.9166 12.049 11 12.248 11C12.4471 11 12.6381 10.9166 12.7795 10.768C12.8493 10.695 12.9048 10.608 12.9427 10.512C12.9805 10.416 13 10.3131 13 10.209C13 10.105 12.9805 10.002 12.9427 9.90605C12.9048 9.81009 12.8493 9.72309 12.7795 9.65009L8.53202 5.23167C8.39026 5.08323 8.19913 5 8 5C7.80087 5 7.60974 5.08323 7.46798 5.23167L3.22049 9.65009C3.15065 9.72309 3.0952 9.81009 3.05735 9.90605C3.01949 10.002 3 10.105 3 10.209C3 10.3131 3.01949 10.416 3.05735 10.512C3.0952 10.608 3.15065 10.695 3.22049 10.768C3.36192 10.9166 3.55292 11 3.75197 11C3.95101 11 4.14201 10.9166 4.28345 10.768L8.00163 7.1444L11.7166 10.768Z",
    fill: "#4B68CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnPaginationChevronUpHover);
export default __webpack_public_path__ + "static/media/icn_pagination_chevron_up_hover.edb73c61685c88b139c022a9ee46f829.svg";
export { ForwardRef as ReactComponent };